export const en = {
  'wallet.balance': 'Balance',
  'wallet.balanceIs': 'Balance {amount}',
  'wallet.topUp': 'Top up',
  'wallet.topUpTitle': 'Top up the balance',
  'wallet.topUpDescription': 'Take the money from {name} first. It is on the balance at once and can only be spent at the bar.',
  'wallet.amount': 'Amount ({currency})',
  'wallet.paidBy': 'Paid by',
  'wallet.note': 'Note',
  'wallet.addAmount': 'Add {amount}',
  'wallet.toppedUp': 'Added {amount}. The balance is now {balance}.',
  'wallet.spendOnly': 'Spend-only: money on the balance is never paid back out.',
  'wallet.history': 'History',
  'wallet.noHistory': 'No balance activity yet',
  'wallet.noHistoryHint': 'Top-ups at the desk and purchases at the bar show here.',
  'wallet.correct': 'Correct',
  'wallet.correctTitle': 'Correct the balance',
  'wallet.correctDescription': 'For mistakes only. The balance never goes below zero, and your reason is kept with the change.',
  'wallet.direction': 'Change',
  'wallet.add': 'Add',
  'wallet.takeOff': 'Take off',
  'wallet.reason': 'Reason',
  'wallet.reasonHint': 'For example: typed 100 instead of 10.',
  'wallet.corrected': 'Balance corrected',
  'wallet.col.when': 'When',
  'wallet.col.what': 'What',
  'wallet.col.amount': 'Amount',
  'wallet.col.after': 'Balance after',
  'wallet.col.by': 'By',
  'wallet.at': 'at {place}',
  'wallet.dailyTitle': 'Balance top-ups',
  'wallet.dailyHint': 'Money members put on their balance. It is held for them, not revenue; cash top-ups are part of the drawer count.',
  'wallet.dailyEmpty': 'No top-ups this day.',
  'memberBalance.title': 'Balance',
  'memberBalance.description': 'Top up at reception, then pay at the bar with your card.',
  'memberBalance.available': 'Available to spend',
  'enum.walletKind.TOP_UP': 'Top-up',
  'enum.walletKind.BAR_CHARGE': 'Bar purchase',
  'enum.walletKind.BAR_REFUND': 'Bar refund',
  'enum.walletKind.CORRECTION': 'Correction',
  'memberBalance.topUp': 'Top up',
  'memberBalance.topUpTitle': 'Top up your balance',
  'memberBalance.topUpHint': 'Pay by card online. The money is on your balance as soon as the bank confirms it, and it is spend-only.',
  'memberBalance.otherAmount': 'Amount ({currency})',
  'memberBalance.amountRange': 'Between {min} and {max}.',
  'memberBalance.pay': 'Pay {amount}',
  'memberBalance.returnPaid': 'The money is on your balance. Spend it at the bar with your card.',
  'memberBalance.returnPending': 'Your balance moves as soon as the bank confirms the payment.',
  'memberBalance.returnFailed': 'The payment did not go through, so your balance is unchanged.',
  'memberBalance.goToBalance': 'Go to balance',
  'enum.walletKind.TOP_UP_REFUND': 'Refunded to card',
  'enum.paymentPurpose.MEMBERSHIP': 'Membership',
  'enum.paymentPurpose.WALLET_TOP_UP': 'Balance top-up',
  'enum.paymentPurpose.APPOINTMENT': 'Session',
  'walletSettings.title': 'Balance top-ups',
  'walletSettings.online': 'Members top up online',
  'walletSettings.onlineHint': 'From the member area, paid through your payment provider. The balance moves only when the bank confirms, and a top-up is never paid back.',
  'walletSettings.limits': 'Online top-up limits ({currency})',
  'walletSettings.min': 'Smallest top-up',
  'walletSettings.max': 'Largest top-up',
  'walletSettings.limitsError': 'Enter a smallest and a largest amount above zero, the largest not below the smallest.',
};

export const ka: Record<keyof typeof en, string> = {
  'wallet.balance': 'ბალანსი',
  'wallet.balanceIs': 'ბალანსი {amount}',
  'wallet.topUp': 'შევსება',
  'wallet.topUpTitle': 'ბალანსის შევსება',
  'wallet.topUpDescription': 'ჯერ მიიღეთ თანხა {name}-სგან. ის მაშინვე აისახება ბალანსზე და მისი დახარჯვა მხოლოდ ბარშია შესაძლებელი.',
  'wallet.amount': 'თანხა ({currency})',
  'wallet.paidBy': 'გადახდის ფორმა',
  'wallet.note': 'შენიშვნა',
  'wallet.addAmount': '{amount}-ის დამატება',
  'wallet.toppedUp': 'დაემატა {amount}. ბალანსი ახლა არის {balance}.',
  'wallet.spendOnly': 'მხოლოდ დასახარჯად: ბალანსზე არსებული თანხა ფულად არ ბრუნდება.',
  'wallet.history': 'ისტორია',
  'wallet.noHistory': 'ბალანსზე მოძრაობა ჯერ არ ყოფილა',
  'wallet.noHistoryHint': 'აქ გამოჩნდება მიმღებთან შევსებები და ბარში შესყიდვები.',
  'wallet.correct': 'შესწორება',
  'wallet.correctTitle': 'ბალანსის შესწორება',
  'wallet.correctDescription': 'მხოლოდ შეცდომების გასასწორებლად. ბალანსი ნულზე ქვემოთ არ ჩამოდის, ხოლო თქვენი მიზეზი ცვლილებასთან ერთად ინახება.',
  'wallet.direction': 'ცვლილება',
  'wallet.add': 'დამატება',
  'wallet.takeOff': 'ჩამოჭრა',
  'wallet.reason': 'მიზეზი',
  'wallet.reasonHint': 'მაგალითად: 10-ის ნაცვლად აიკრიფა 100.',
  'wallet.corrected': 'ბალანსი შესწორდა',
  'wallet.col.when': 'როდის',
  'wallet.col.what': 'რა',
  'wallet.col.amount': 'თანხა',
  'wallet.col.after': 'ბალანსი შემდეგ',
  'wallet.col.by': 'ვინ',
  'wallet.at': '{place}',
  'wallet.dailyTitle': 'ბალანსის შევსებები',
  'wallet.dailyHint': 'თანხა, რომელიც წევრებმა ბალანსზე შეიტანეს. ის მათთვის ინახება და შემოსავალი არ არის; ნაღდი შევსებები სალაროს დათვლაში შედის.',
  'wallet.dailyEmpty': 'ამ დღეს შევსება არ ყოფილა.',
  'memberBalance.title': 'ბალანსი',
  'memberBalance.description': 'შეავსეთ ბალანსი მიმღებთან და გადაიხადეთ ბარში თქვენი ბარათით.',
  'memberBalance.available': 'ხელმისაწვდომი თანხა',
  'enum.walletKind.TOP_UP': 'შევსება',
  'enum.walletKind.BAR_CHARGE': 'ბარში შესყიდვა',
  'enum.walletKind.BAR_REFUND': 'ბარის დაბრუნება',
  'enum.walletKind.CORRECTION': 'შესწორება',
  'memberBalance.topUp': 'შევსება',
  'memberBalance.topUpTitle': 'ბალანსის შევსება',
  'memberBalance.topUpHint': 'გადაიხადეთ ბარათით ონლაინ. თანხა ბალანსზე აისახება, როგორც კი ბანკი დაადასტურებს; ის მხოლოდ დასახარჯია.',
  'memberBalance.otherAmount': 'თანხა ({currency})',
  'memberBalance.amountRange': '{min}-დან {max}-მდე.',
  'memberBalance.pay': 'გადახდა {amount}',
  'memberBalance.returnPaid': 'თანხა ბალანსზეა. დახარჯეთ ბარში თქვენი ბარათით.',
  'memberBalance.returnPending': 'ბალანსი შეიცვლება, როგორც კი ბანკი გადახდას დაადასტურებს.',
  'memberBalance.returnFailed': 'გადახდა ვერ შესრულდა, ამიტომ ბალანსი არ შეცვლილა.',
  'memberBalance.goToBalance': 'ბალანსზე გადასვლა',
  'enum.walletKind.TOP_UP_REFUND': 'ბარათზე დაბრუნდა',
  'enum.paymentPurpose.MEMBERSHIP': 'აბონემენტი',
  'enum.paymentPurpose.WALLET_TOP_UP': 'ბალანსის შევსება',
  'enum.paymentPurpose.APPOINTMENT': 'სესია',
  'walletSettings.title': 'ბალანსის შევსება',
  'walletSettings.online': 'წევრები ბალანსს ონლაინ ავსებენ',
  'walletSettings.onlineHint': 'წევრის კაბინეტიდან, თქვენი გადახდის პროვაიდერით. ბალანსი იცვლება მხოლოდ ბანკის დადასტურების შემდეგ; შევსებული თანხა უკან არ ბრუნდება.',
  'walletSettings.limits': 'ონლაინ შევსების ზღვრები ({currency})',
  'walletSettings.min': 'მინიმალური შევსება',
  'walletSettings.max': 'მაქსიმალური შევსება',
  'walletSettings.limitsError': 'მიუთითეთ ნულზე მეტი მინიმალური და მაქსიმალური თანხა; მაქსიმალური არ უნდა იყოს მინიმალურზე ნაკლები.',
};
